module.exports = __webpack_public_path__ + "img/horizontal_3_6_6005.08fff8dd.png";